export default "__VITE_ASSET__CXbNhgIJ__"